document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.getElementById('load-more-upsell');
  const upsellWrapper = document.querySelector('.cocktail-featured-section__upsell-slides-wrapper');

  const moreText = loadMoreBtn.getAttribute('data-more-text');
  const lessText = loadMoreBtn.getAttribute('data-less-text');

  const moreIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
      <path d="M20.0007 9.30225V32.6356M8.33398 20.9689H31.6673" stroke="#706B57" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const lessIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
      <path d="M8.83398 20.9712H32.1673" stroke="#706B57" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  loadMoreBtn.addEventListener('click', function () {
    if (window.innerWidth <= 768) {
      const isExpanded = upsellWrapper.classList.toggle('expanded');
      loadMoreBtn.querySelector('.text').textContent = isExpanded ? lessText : moreText;
      loadMoreBtn.querySelector('.icon').innerHTML = isExpanded ? lessIcon : moreIcon;
    }
  });
});